const getGraphQLErrorMessage = (error, fallback) => {
	const message = error?.graphQLErrors?.[0]?.message ||
		error?.errors?.[0]?.message ||
		error?.message;
	const normalizedMessage = typeof message === 'string'
		? message.replace(/^GraphQL error:\s*/, '').trim()
		: '';

	return normalizedMessage || fallback;
};

export default getGraphQLErrorMessage;
